query CspBrandsIndex(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  cspBrandsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        insertedAt
        updatedAt

        active

        origin_id

        
        entityType
        tcr_csp_id
        tcr_brand_id
      
        firstName
        lastName
        displayName
        companyName
        ein
        einIssuingCountry
        phoneNumber
        mobilePhoneNumber
        street
        city
        state
        postalCode
        country
        email
        stockSymbol
        stockExchange

        ipAddress

        website
        brandRelationship
        vertical
        altBusinessId
        altBusinessIdType

        universalEin
        referenceId
        optionalAttributes
        isMock

        identityStatus
        registrationScore

        account {
          id
          name
        }
      }
    }
  }
}
